import { Component, OnInit, Input,ViewChild } from '@angular/core';
import { NavParams, ModalController,Platform,IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { MessageclientService } from 'src/service/messageclient.service';
import { ActivatedRoute } from '@angular/router';
import { WebParameterContext,WebResponesContext } from 'src/model/common';
declare var app;
@Component({
  selector: 'app-selectionpage',
  templateUrl: './selectionpage.page.html',
  styleUrls: ['./selectionpage.page.scss'],
})
export class SelectionpagePage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  dataArrayList:Array<any> = [];
  PageNumber:number =1; // 当前第几页  默认的是第一页
  /**
   * 接口状态
   */
  apiObj ={
    status: false,
    mag: ''
  }
  loading: boolean = false; //加载效果
  isSearch:boolean = true; //获取是否有查询条件
  RecordCount: Number = 0; // 列表总数量
  searchValue:any = ""; //查询条件
  webRespone:WebResponesContext = new WebResponesContext();//返回结果处理对象 //返回处理结果
  checkedAll:boolean = false; //判断是全选或者反选
  constructor(
    public platform: Platform,
    public modalController: ModalController,
    public navParams: NavParams,
    public http:HttpCustomerService,
    public com:CommonService,
    public msg:MessageclientService,
    private activaRouter: ActivatedRoute
  ) { 
    console.log(navParams.get('firstName'));
  }
  list = [
    {
      title: 'Ant Design Title 1Ant Design Title 1Ant Design Title 1Ant Design Title 1Ant Design Title 1',
      id: 1,
      checked: true
    },
    {
      title: 'Ant Design Title 2',
      id: 26,
      checked: false
    },
    {
      title: 'Ant Design Title 3',
      id: 37,
      checked: false
    },
    {
      title: 'Ant Design Title 4',
      id: 48,
      checked: false
    },
    {
      title: 'Ant Design Title 5',
      id: 599,
      checked: false
    },
    {
      title: 'Ant Design Title 6',
      id: 68,
      checked: false
    }
  ];
  // id集合
  idArr:any= [] 
  checked: boolean = false;
  selectAll:boolean = true;
  step: number = 1;
  ngOnInit() {
    // this.initCheckedIdArr();
    this.LoadData(1);
  }
  
  /**
   * @param e
   * 搜索事件
   */
  serarEvent(e,type:string = 'type'){
    const that = this;
    if(e.keyCode == 13 || type == 'search'){
      if(that.searchValue){
       that.LoadData(that.PageNumber)
      }
    }
  }
    /**
   * 加载类型的列表
   * @param num 对应列表
   */
  btn_change(num){
    if(this.step == num){
      this.step = 0;
    }else{
      this.step = num;
    }
  }
  /**
   * 请求列表数据，不同条件数据改变
   * @param PageNumber  当前页数的变化
   */
  LoadData(PageNumber){
    console.log("页数++++++++++++++++++++++++")
    console.log(PageNumber)
    let that = this;
    console.log("列表数据列表数据列表数据")
    that.PageNumber = PageNumber;
    if(PageNumber == 1){
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';

    }
    let checkItems:Array<string> = new Array<string>();
  if(that["checkItem"]){//获取选中样品/礼品的值的ID;
    checkItems=that["checkItem"];
  }
  //
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName ="TBSampleGiftsXML"; //接口名称
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "publicselection";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody={};
    // body.RequestBody["a_FK_TBProductInformation_ID"]=that["ids"];//获取产品ID；
    if(that.searchValue){
      body.RequestBody["a_Name"]=that.com.LikeSearch(that.searchValue);
    }
    body.RequestBody = JSON.stringify(body.RequestBody); // 参数转成json

    // 传参获取数据
    /**
     * url boby
     */
    that.http.post(app.DEFAULTURL,body).then(data =>{
      /**
       * 判断是否是第一页
       */
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success; // 成功的状态
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage; //网络异常
        that.loading  = true;
      }else{
        if(that.infiniteScroll){
          that.infiniteScroll.complete()
        }
      }
      // 如果数据成功
      if(data.ResponseMessage.Success){
        data.Status.Datas.forEach(function(item){
          let objtemp: any = {};
          objtemp["id"] = item.FK_TBGift_ID; // 赠品主键
          objtemp["checked"] = false;  // 默认数据没选中

          if(checkItems.length>0){
              if(checkItems.findIndex(IDitem =>IDitem== objtemp.id)!= -1 ){
                objtemp["checked"] = true;
              }
          }
          // 数据内容
          // console.log("礼品名称礼品名称========")
          // console.log(data.Status.Datas)
          // console.log("礼品名称礼品名称")
          // console.log(item.GiftName)
          // console.log(item.Stock)
          // console.log(item.StoreName)
          objtemp["Name"] = item.GiftName; //礼品名称
          objtemp["Num"] = item.Stock; //礼品数量
          objtemp["StoreName"] = item.StoreName; //
          that.dataArrayList.push(objtemp); //添加数据
          // console.log("组合数据=========================")
          // console.log( that.dataArrayList)
        })

        /**
         * 上拉加载数据
         */
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          if(that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if(that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        // 数据异常出现的报错
      }else{
          // that.dataArrayList=new Array<any>();
      that.apiObj['status'] = false;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
      }

    }).catch(error =>{
      that.apiObj ['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }


  /**
   * 下拉刷新数据
   */
  doRefresh(event){
    this.LoadData(1);
    event.target.pullMax = 500;
    event.target.pullMin=100;
    event.target.complete();

  }
  /**
   * 上拉分页
   * @param event
   */
  loadMoreData(event){
    let that = this;
     if(that.RecordCount == that.dataArrayList.length){
       if(that.infiniteScroll){
         that.infiniteScroll.disabled = true;
       }
     }else{
       that.PageNumber++;
       that.LoadData(that.PageNumber);
     }
  }
  // 取消按钮
  dismissModal() {
    const that=this;
    that.webRespone.Status=new Array<any>();
    that.webRespone.ResponseMessage.Success=false;
    that.modalController.dismiss({
      "result":  that.webRespone,
      "checked":that.checkedAll
    });
  }

  // 确定按钮
  comfireModal() {
   const that = this;
   that.webRespone.Status=new Array<any>();
   that.webRespone.ResponseMessage.Success=true;
   if(that.dataArrayList.length >0){
     that.dataArrayList.forEach(che=>{
       if(che.checked){
         that.webRespone.Status.push(che)
       }
     })
   }
    this.modalController.dismiss({
      "result": that.webRespone,
      "checked":that.checkedAll
    });

  }

  /**
   * 
   * @param item 初始化默认选中的id集合
   */
  // initCheckedIdArr() {
  //   let that = this
  //   // 先清空
  //   that.idArr = []
  //   that.list.forEach(item=>{
  //     if (item.checked) {
  //       that.idArr.push(item.id)
  //     }
  //   })
  // }

  /**
   * 公共礼品选择
   * @param item 当前点击项
   */
  // click(item) {
  //   let that = this
  //   let clickId = item.id 
  //   that.list.forEach(theItem=>{
  //     if(clickId === theItem.id) {
  //       theItem.checked = !theItem.checked
  //       // 判断此时状态
  //       if(theItem.checked) {
  //         // 存储id
  //         that.idArr.push(theItem.id)
  //       } else {
  //         // 取消选择，则删除id 
  //         that.idArr.splice(that.idArr.indexOf(theItem.id),1)
  //       }
  //     }
  //   })
  //   console.log("当前的id集合：",that.idArr)
  // }

  // onInput(item,e){
  //   const that = this;
  //   console.log(item)
  //   console.log("eeeeeeeeeeeeeee",e)
  //   item.checked = e.target.checked;
  //   console.log(item,"当前的id集合：");
  // }
  onInput(item,e) {
    const that=this;
    item.checked=e.target.checked;
   if( item.checked){
    that.list.forEach(it => {
      if(it.id !==item.id) {
            it.checked = false;
        }
    })
   }
   
    console.log(item,"当前的id集合：");
  }
/**
 * 全选
 */
checkAll(e){
  const that=this;
  console.log("门店类型");
  const check = e.target.checked;
  that.dataArrayList.forEach(item=>{
    item.checked=check;
  });
  that.checkedAll=check;
}
}
